import React, { useContext, useEffect, useState } from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import { isSafari } from 'react-device-detect'
import Tooltip from '@material-ui/core/Tooltip'
import HelpRounded from '@material-ui/icons/HelpRounded'
import { withStyles } from '@material-ui/core/styles'
import * as d3 from 'd3'
import charts from '../data/relationsData'
import PageSection from '../components/PageSection'
import LineChart from '../components/LineChart'
import StackedAreaChart from '../components/StackedAreaChart'
import ChartDialog from '../components/ChartDialog'
import { filterItemsByRange } from '../ultils/dateUtils'
import expandIcon from '../assets/images/expandNew.svg'
import closePopupIcon from '../assets/images/colosePopup.svg'
import ChartD3ToggleGroup from '../components/ChartD3ToggleGroup'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { formatScanChartData } from '../ultils/dataUtil'
import FilterBoxCommon from '../components/FilterBoxCommon'
import ChartTooltipModal from '../components/ChartTooltipModal'
import { getChartColorRange, showingScanChart } from '../ultils/chart-d3-utils'

let _ = require('lodash')

export const filterData = [
  { id: 0, value: '2 years' },
  { id: 1, value: '5 years' },
  { id: 2, value: '10 years' },
]

const useStyles = makeStyles({
  chartDiv: {
    position: 'relative',
    padding: '8px 0px 0px 20px !important',
  },
  chartDivFirst: {
    position: 'relative',
    padding: '8px 0px 0px 0px !important',
  },
  subheadingTitle: {
    marginRight: 7,
  },
  subheading: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '22px',
    color: '#181818',
    display: 'flex',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    alignItems: 'center',
    '& img': {
      width: 19,
      height: 25,
      marginLeft: 5,
      cursor: 'pointer',
    },
  },
  subheadingInModal: {
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '28px',
    color: '#181818',
    display: 'flex',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    alignItems: 'center',
    '& img': {
      width: 19,
      height: 25,
      marginLeft: 5,
      cursor: 'pointer',
    },
  },
  subTitle: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    marginLeft: 5,
    color: '#757575',
  },
  subTitleInModal: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '24px',
    marginLeft: 5,
    color: '#757575',
  },
  modalHeaderControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    whiteSpace: 'nowrap',
  },
  closeBtn: {
    width: 36,
    height: 36,
    borderRadius: 999,
    background: '#F2F2F2',
  },
  help: {
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
    },
    '& svg': {
      // width: 20,
      // height: 20,
      // marginLeft: 5,
      // cursor: 'pointer',
      // color: '#474747',
    },
  },
  smallLineChart: {
    height: '204px',
    maxWidth: '100%',
    position: 'relative',
  },
  fullLineChart: {
    height: 'calc(100% - 100px)',
    maxWidth: '100%',
  },
  fullStackAreaChart: {
    height: 'calc(100% - 100px)',
    maxWidth: '100%',
  },
  marketContextContainer: {
    margin: '10px 0px 0px 0px',
    width: '100%',
    background: '#fff',
    '& .MuiGrid-item': {
      // padding: '16px 12px 0px 12px',
    },
  },
  chartHeader: {
    color: '#474747',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: -10,
  },
  chartHeaderInModal: {
    color: '#474747',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
    paddingBottom: 20,
    borderBottom: '1px solid #E1E6EF',
  },
  menuDateGroup: {
    '& .MuiPaper-root': {
      '& .MuiList-root': {
        padding: 0,
        borderRadius: 'unset',
        '& .MuiButtonBase-root': {
          minHeight: 'unset',
          fontSize: 14,
          lineHeight: '18px',
          fontWeight: 'normal',
          color: '#474747',
        },
      },
    },
  },
  formControlDate: {
    marginLeft: 20,
    width: '100%',
    minWidth: 190,
    '& .MuiFormLabel-root': {
      fontSize: 12,
      lineHeight: '18px',
      transform: 'none',
      marginBottom: 8,
      position: 'unset',
    },
    '& .MuiInputBase-root': {
      height: 40,
      marginTop: 'unset',
      backgroundColor: '#F4F5F7',
      borderRadius: '3px',
      display: 'unset',
      '& .MuiSelect-root': {
        height: '100%',
        fontSize: 14,
        lineHeight: '18px',
        fontWeight: 400,
        color: '#474747',
        padding: '0px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: 'transparent !important',
        paddingLeft: 10,
      },
      '& svg': {
        position: 'absolute',
        right: 10,
        top: 6,
        width: 9,
        transform: 'rotate(180deg)',
      },
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
  },
  legend: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: 10,
    padding: '20px 0px 17px 0px',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      marginRight: 16,
      '& div': {
        marginRight: 4,
        width: 8,
        height: 8,
        borderRadius: '50%',
      },
    },
  },
  composition: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 40,
  },
  label: {
    fontSize: 14,
    lineHeight: '18px',
    marginRight: 16,
  },
  filterYearContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  filterTitlte: {
    fontSize: 12,
    lineHeight: '24px',
    fontWeight: 400,
    color: '#474747',
    marginRight: 16,
  },
  customToggleContainer: {
    paddingLeft: 0,
  },
  viewByTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
    marginRight: 16,
  },
  toggleBtnContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  compositionComplex: {
    paddingTop: 16,
  },
  modalStackHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 12,
    marginBottom: 8,
  },
  modalTabsWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  legendInline: {
    padding: 0,
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'Regular',
    fontSize: 12,
    lineHeight: '18px',
    letterPacing: 0,
    verticalAlign: 'middle',
    color: '#474747',
  },
  toggleContainer: {
    borderTop: '1px solid #DFE4EB',
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    padding: '16px 0px 0px 0px !important',
    margin: '20px 0px 10px 0px',
  },
  button: {
    cursor: 'pointer',
    verticalAlign: 'text-top',
    marginLeft: 5,
    height: '20px',
    color: '#fff',
    backgroundColor: '#1B3963',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: 8,
    padding: '2px 3px',
    '&:hover': {
      backgroundColor: '#1B3963',
      color: '#fff',
    },
  },
  expandIcon: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#1B3963',
    background: '#EDF2F7',
    borderRadius: 4,
    width: 32,
    height: 32,
    '& img': {
      width: 32,
      height: 32,
    },
    '& svg': {
      width: 32,
    },
  },
  toolTip: {
    color: '#8D9CB1',
    width: 16,
    height: 16,
    fontSize: 16,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 2,
  },
  toolTipInModal: {
    color: '#8D9CB1',
    width: 20,
    height: 20,
    fontSize: 20,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 10,
  },
  fundamentalTabGroup: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 18,
    borderBottom: '1px solid #DFE4EB',
  },
  fundamentalTabButton: {
    height: 22,
    padding: '0 0 6px',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#757575',
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    borderBottom: '2px solid transparent',
    marginBottom: -1,
  },
  fundamentalTabButtonActive: {
    color: '#181818',
    fontWeight: 600,
    borderBottom: '2px solid #1B3963',
  },
})
const CustomToolTip = withStyles({
  tooltip: {
    backgroundColor: 'transparent !important',
    boxShadow: 'unset !important',
  },
})(Tooltip)

const FUNDAMENTAL_TOGGLE_LIST = [
  { id: 0, value: 'Show absolute value' },
  { id: 2, value: 'Show % value' },
]

const ENABLE_STORY_LOGIC = false

const Fundamentals = ({ tickerId }) => {
  const classes = useStyles()
  const { state, setShowPeerToggle, setShowCompanyToggle } = useContext(
    PortfolioContext,
  )
  const [selection, setSelection] = useState(null)
  const [message, setMessage] = useState(null)
  const [isOpenExpandModal, setOpenExpandModal] = React.useState(false)
  const [chartDetail, setChartDetail] = React.useState({})
  const [viewBy, setViewBy] = React.useState(null)
  const [chartsData, setChartsData] = useState(charts)
  const [filter, setFilter] = useState({ id: 1, value: '5 years' })
  const [showingToggle, setShowingToggle] = useState(true)
  const [toggleObj, setToggleObj] = useState({
    showCompanyHistory: true,
    showPeerGroup: false,
  })
  const [showComposition, setShowComposition] = useState(false)
  const [openTooltip, setOpenTooltip] = React.useState(false)
  const [tooltipInfo, setTooltipInfo] = React.useState({})
  const handleClickOpenTooltip = chart => {
    setOpenTooltip(true)
    const info =
      chart.chart_type === 'base_scan'
        ? chart.tooltipInfo.corporate
        : chart.chart_type === 'bank_scan'
        ? chart.tooltipInfo.bank
        : chart.tooltipInfo.property
    setTooltipInfo(info)
  }

  useEffect(() => {
    if (state.fundamentalData.length === 9) {
      charts.forEach(chart => {
        state.fundamentalData.forEach(lData => {
          if (chart.id === lData.chartId) {
            chart.data = formatScanChartData(lData.data)
            chart.chart_type = lData.chart_type
          }
        })
      })
    }
    const chartsCopy = _.cloneDeep(charts)
    const chartFilterData = chartsCopy.map(i => filterChartProps(i))
    setChartsData(chartFilterData)

    const lineChartsForToggle = chartsCopy.filter(
      chart => chart.type === 'LineChart',
    )

    const showPeerToggle = lineChartsForToggle
      .reduce(
        (bool, chart) =>
          bool ||
          chart.data.reduce(
            (acc, curr) =>
              acc ||
              !(
                curr[
                  chart.chart_type === 'bank_scan'
                    ? chart.lineKeys.bank[1]
                    : chart.lineKeys.corporate[1]
                ] === null ||
                curr[
                  chart.chart_type === 'bank_scan'
                    ? chart.lineKeys.bank[1]
                    : chart.lineKeys.corporate[1]
                ] === 0
              ),
            false,
          ),
        false,
      )

    const showCompanyToggle = lineChartsForToggle
      .reduce(
        (bool, chart) =>
          bool ||
          chart.data.reduce(
            (acc, curr) =>
              acc ||
              !(
                curr[
                  chart.chart_type === 'bank_scan'
                    ? chart.lineKeys.bank[0]
                    : chart.chart_type === 'property_scan'
                    ? chart.lineKeys.property[0]
                    : chart.lineKeys.corporate[0]
                ] === null ||
                curr[
                  chart.chart_type === 'bank_scan'
                    ? chart.lineKeys.bank[0]
                    : chart.chart_type === 'property_scan'
                    ? chart.lineKeys.property[0]
                    : chart.lineKeys.corporate[0]
                ] === 0
              ),
            false,
          ),
        false,
      )

    // Default peer group off; force on only if company data missing or edge case.
    let edgeCase = false
    let showingToggle = true
    lineChartsForToggle.map(chart => {
      let historicalDataEmpty = true
      let peerGroupDataEmpty = true
      chart.data.map(d => {
        const historyData =
          d[
            chart.chart_type === 'bank_scan'
              ? chart.lineKeys.bank[0]
              : chart.chart_type === 'property_scan'
              ? chart.lineKeys.property[0]
              : chart.lineKeys.corporate[0]
          ]
        const peerGroupData =
          d[
            chart.chart_type === 'bank_scan'
              ? chart.lineKeys.bank[1]
              : chart.chart_type === 'property_scan'
              ? chart.lineKeys.property[1]
              : chart.lineKeys.corporate[1]
          ]
        if (historyData) {
          historicalDataEmpty = false
        }
        if (peerGroupData) {
          peerGroupDataEmpty = false
        } else {
          showingToggle = false
        }
      })

      if (historicalDataEmpty && !peerGroupDataEmpty) {
        edgeCase = true
      }
    })

    setShowingToggle(showingToggle)
    setShowPeerToggle(showPeerToggle)
    setShowCompanyToggle(showCompanyToggle)
    const shouldForcePeerGroup = !showCompanyToggle || edgeCase
    setToggleObj(prev => ({
      ...prev,
      showPeerGroup: shouldForcePeerGroup ? true : prev.showPeerGroup,
    }))
  }, [state.fundamentalData])

  useEffect(() => {
    const text = selection?.text
    const title = selection?.title
    const id = selection?.id
    if (!selection) {
      setMessage(null)
    } else {
      setMessage({ text, title, id })
    }
  }, [selection])

  const handeExpandChart = chart => {
    setChartDetail(chartsData.filter(i => i.id === chart.id)[0])
    setViewBy(chart.id)
    setOpenExpandModal(true)
  }

  const handleChangeViewBy = val => {
    setViewBy(val.value)
    setChartDetail(chartsData.filter(i => i.id === val.id)[0])
  }

  const filterChartProps = chart => {
    const chartCopy = _.cloneDeep(charts.filter(i => i.id === chart.id)[0])
    if (chartCopy.type === 'StackedAreaChart') {
      return chart
    }
    const lineKeys = Object.keys(chartCopy?.data[0] || []).filter(
      item =>
        item !== 'dateString' &&
        item !== 'chart_name' &&
        item !== 'chart_number' &&
        item !== 'date',
    )

    chartCopy.data.map(data => {
      if (toggleObj.showCompanyHistory && toggleObj.showPeerGroup) {
      } else if (!toggleObj.showCompanyHistory && !toggleObj.showPeerGroup) {
        delete data[`${lineKeys[0]}`]
        delete data[`${lineKeys[1]}`]
      } else if (toggleObj.showCompanyHistory && !toggleObj.showPeerGroup) {
        delete data[`${lineKeys[1]}`]
      } else {
        delete data[`${lineKeys[0]}`]
      }
    })

    return chartCopy
  }

  const renderStackAreaLegends = (stackKeys, colorRanges) => {
    let indents = []
    for (let i = 0; i < stackKeys.length; i++) {
      indents.push(
        <div>
          <div
            style={{
              backgroundColor: `${colorRanges[stackKeys.length - 1 - i]}`,
            }}
          />
          {stackKeys[i].title}
        </div>,
      )
    }
    return indents
  }

  const getStackKeys = (chart, stackKeys) => {
    return stackKeys?.filter(stackKey => {
      let exist = false
      chart.data.map(d => {
        exist = exist || (d[stackKey.key] !== null && d[stackKey.key] !== 0)
      })
      return exist
    })
  }

  const chartDiv = (chart, inModal, filterValue) => {
    let stackKeys =
      chart.chart_type === 'base_scan'
        ? chart?.stackKeys?.corporate
        : chart.chart_type === 'bank_scan'
        ? chart?.stackKeys?.bank
        : chart?.stackKeys?.property
    stackKeys = getStackKeys(chart, stackKeys)
    const lineKeys =
      chart.chart_type === 'base_scan'
        ? chart?.lineKeys?.corporate
        : chart.chart_type === 'bank_scan'
        ? chart?.lineKeys?.bank
        : chart?.lineKeys?.property

    const colorRanges = getChartColorRange(stackKeys?.length)

    const getChartTitle = chart => {
      return !chart.chart_type
        ? chart.title
        : chart.chart_type === 'base_scan'
        ? chart?.tooltipInfo?.corporate?.title || ''
        : chart.chart_type === 'bank_scan'
        ? chart?.tooltipInfo?.bank?.title || ''
        : chart?.tooltipInfo?.property?.title || ''
    }

    const getChartSubTitle = chart => {
      return !chart.chart_type
        ? chart.title
        : chart.chart_type === 'base_scan'
        ? `(${chart?.tooltipInfo?.corporate?.subTitle})` || ''
        : chart.chart_type === 'bank_scan'
        ? `(${chart?.tooltipInfo?.bank?.subTitle})` || ''
        : `(${chart?.tooltipInfo?.property?.subTitle})` || ''
    }

    return (
      <Grid
        key={chart.id}
        id={chart.id}
        item
        xs={12}
        sm={!inModal ? (chart.type === 'StackedAreaChart' ? 4 : 12) : 12}
        style={{
          opacity:
            selection && ENABLE_STORY_LOGIC
              ? selection.relationships.includes(chart.id) ||
                selection.id === chart.id
                ? 1
                : 0.3
              : 1,
        }}
        className={
          [1, 2, 3].includes(chart.id)
            ? classes.chartDivFirst
            : classes.chartDiv
        }
      >
        {/* selection !== null && chart.id !== undefined && selection.id === chart.id && <Snackbar message={message} id={selection.id}/> */}
        <div
          className={inModal ? classes.chartHeaderInModal : classes.chartHeader}
        >
          <div
            className={inModal ? classes.subheadingInModal : classes.subheading}
          >
            {getChartTitle(chart)}
            <HelpRounded
              className={inModal ? classes.toolTipInModal : classes.toolTip}
              key={chart.id}
              onClick={() => handleClickOpenTooltip(chart)}
            />
            {chart.type === 'LineChart' && (
              <span
                className={inModal ? classes.subTitleInModal : classes.subTitle}
              >
                {getChartSubTitle(chart)}
              </span>
            )}
          </div>
          <div className={classes.help}>
            {inModal && (
              <div className={classes.modalHeaderControls}>
                <Typography className={classes.label}>View by</Typography>
                <FilterBoxCommon
                  placeholder={getChartTitle(chart)}
                  data={getDropdownListChart(chartsData).map(item => {
                    return {
                      ...item,
                      value: getChartTitle(item),
                    }
                  })}
                  selectedValue={getChartTitle(chart)}
                  setFilterValue={val => handleChangeViewBy(val)}
                  isSearch={false}
                  isRadio
                  customStyle={{ width: 260 }}
                  customStyleBody={{ width: 320 }}
                  outSelectedItems={[]}
                />
                <input
                  className={classes.closeBtn}
                  type="image"
                  onClick={() => setOpenExpandModal(false)}
                  src={closePopupIcon}
                  alt="closeBtn"
                />
              </div>
            )}
            {!inModal && !isOpenExpandModal && !isSafari && (
              <img
                src={expandIcon}
                className={`${classes.expandIcon} tooltip`}
                onClick={() => handeExpandChart(chart)}
                id={`expandChartBtn-chart-${chart.id}`}
              />
            )}
          </div>
        </div>
        {inModal && chart.type === 'StackedAreaChart' && (
          <div className={classes.modalStackHeader}>
            <div className={classes.modalTabsWrap}>
              {renderFundamentalTabs()}
            </div>
            <div className={`${classes.legend} ${classes.legendInline}`}>
              {renderStackAreaLegends(stackKeys, colorRanges)}
            </div>
          </div>
        )}
        {inModal && chart.type === 'LineChart' && showingToggle && (
          <ChartD3ToggleGroup
            setToggleObj={val => setToggleObj(val)}
            toggleObj={toggleObj}
            inModal={inModal}
            showPeerGroup={state.showPeerToggle}
            showCompany={state.showCompanyToggle}
            variant="legend"
          />
        )}

        <div
          className={
            !inModal
              ? classes.smallLineChart
              : inModal && chart.type === 'LineChart'
              ? classes.fullLineChart
              : classes.fullStackAreaChart
          }
        >
          {(() => {
            if (chart && chart.type === 'LineChart') {
              return (
                <LineChart
                  key={chart.id}
                  lineKeys={lineKeys}
                  inModal={inModal}
                  chartId={chart.id}
                  data={filterItemsByRange(chart.data, filterValue)}
                  relations={chart}
                  setSelection={setSelection}
                />
              )
            }
            if (chart && chart.type === 'StackedAreaChart') {
              return (
                <StackedAreaChart
                  inModal={inModal}
                  key={chart.id}
                  chartId={chart.id}
                  stackKeys={stackKeys}
                  data={filterItemsByRange(chart.data, filterValue)}
                  relations={chart}
                  setSelection={setSelection}
                  showComposition={showComposition}
                />
              )
            }
            return <span />
          })()}
        </div>
      </Grid>
    )
  }

  useEffect(() => {
    const chartsCopy = _.cloneDeep(charts)
    const chartFilterData = chartsCopy.map(i => filterChartProps(i))
    setChartsData(chartFilterData)
    if (chartDetail.id) {
      setChartDetail(chartFilterData.filter(c => c.id === chartDetail.id)[0])
    }
  }, [toggleObj])

  const handleToggleFundamental = val => {
    if (JSON.stringify(FUNDAMENTAL_TOGGLE_LIST[0]) === JSON.stringify(val)) {
      setShowComposition(false)
    }
    if (JSON.stringify(FUNDAMENTAL_TOGGLE_LIST[1]) === JSON.stringify(val)) {
      setShowComposition(true)
    }
  }

  const renderFundamentalTabs = () => {
    const activeTabId = showComposition
      ? FUNDAMENTAL_TOGGLE_LIST[1].id
      : FUNDAMENTAL_TOGGLE_LIST[0].id

    return (
      <div className={classes.fundamentalTabGroup}>
        {FUNDAMENTAL_TOGGLE_LIST.map(item => {
          const isActive = item.id === activeTabId
          return (
            <button
              key={item.id}
              type="button"
              className={`${classes.fundamentalTabButton} ${
                isActive ? classes.fundamentalTabButtonActive : ''
              }`}
              onClick={() => handleToggleFundamental(item)}
            >
              {item.value}
            </button>
          )
        })}
      </div>
    )
  }

  const getCompositionChart = charts => {
    return charts.filter(c => c.type === 'StackedAreaChart')
  }

  const getScanCharts = (charts, group) => {
    return charts.filter(
      c => c.type === 'LineChart' && c.group === group && c.data.length > 1,
    )
  }

  const getDropdownListChart = charts => {
    return charts.filter(c => c.data.length > 1)
  }

  return (
    <PageSection
      title="Fundamentals"
      subTitle="Funding, Assets & Operational Outputs"
      fundamentalTooltip
    >
      <div
        className={classes.filterYearContainer}
        // the id indicates this element is ignored when generating pdf
        id="filterByBox"
      >
        <span className={classes.filterTitlte}>Filter by</span>
        <FilterBoxCommon
          placeholder={filterData[1].value}
          data={filterData}
          selectedValue={filter.value}
          setFilterValue={val => setFilter(val)}
          isSearch={false}
          isRadio
          customStyle={{ width: '170px' }}
        />
      </div>
      <>
        <div className={classes.compositionComplex}>
          {renderFundamentalTabs()}
        </div>
        <Grid className={classes.marketContextContainer} container spacing={3}>
          {getCompositionChart(chartsData).map(chart =>
            chartDiv(chart, false, filter.id),
          )}

          {showingScanChart(chartsData) && showingToggle && (
            <Grid item xs={12} sm={12} className={classes.toggleContainer}>
              <ChartD3ToggleGroup
                setToggleObj={val => setToggleObj(val)}
                toggleObj={toggleObj}
                showPeerGroup={state.showPeerToggle}
                showCompany={state.showCompanyToggle}
                variant="legend"
              />
            </Grid>
          )}

          {showingScanChart(chartsData) && (
            <Grid container>
              <Grid item xs={4} sm={4}>
                {getScanCharts(chartsData, 'A').map(chart =>
                  chartDiv(chart, false, filter.id),
                )}
              </Grid>
              <Grid item xs={4} sm={4}>
                {getScanCharts(chartsData, 'B').map(chart =>
                  chartDiv(chart, false, filter.id),
                )}
              </Grid>
              <Grid item xs={4} sm={4}>
                {getScanCharts(chartsData, 'C').map(chart =>
                  chartDiv(chart, false, filter.id),
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
        <ChartDialog
          chart={chartDiv(chartDetail, true, filter.id)}
          isOpenExpandModal={isOpenExpandModal}
          setOpenExpandModal={value => {
            d3.selectAll(`.line-chart${chartDetail.id}-inModal`).remove()
            d3.selectAll(`.stackarea-chart${chartDetail.id}-inModal`).remove()
            setOpenExpandModal(value)
          }}
        />
        <ChartTooltipModal
          open={openTooltip}
          handleClose={() => {
            setOpenTooltip(false)
          }}
          tooltipInfo={tooltipInfo}
        />
      </>
    </PageSection>
  )
}

export default Fundamentals
